const data = {
  organization_name: 'infobae.com',
  last_update: '25-05-2022T10:00Z',
  election: {
    title: 'Presidente Colombia 2022 Mayo',
    key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    type: 'Primer Vuelta',
    charge: 'Presidente',
    charge_type: 'president',
    region: {
      country: 'Colombia',
      state: 'All',
      state_code: 'CO',
      city: '',
    },
    tables: {
      available_voters: 0,
      qty: 0,
      percent: 0,
    },
    total_votes: {
      qty: 0,
      percent: 0,
    },
  },
  parties: [
    {
      votes: 0,
      votes_percent: 0,
      party_id: '1',
      name: 'Liga de Gobernantes Anticorrupción',
      candidates: [
        {
          candidate_id: 'Presidente',
          fullname: 'Rodolfo Hernández',
          votes: 0,
          votes_percent: 0,
          block_name: 'Liga de Gobernantes Anticorrupción',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/rodolfo-hernandez.png',
        },
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Marelen Castillo',
          votes: 0,
          votes_percent: 0,
          block_name: 'Liga de Gobernantes Anticorrupción',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/marelen-castillo.png',
        },
      ],
      block: 'Liga de Gobernantes Anticorrupción',
      settings: {
        color: '#F9AC29',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '2',
      name: 'Colombia Justa Libres',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Sandra Torres',
          votes: 0,
          votes_percent: 0,
          block_name: 'Colombia Justa Libres',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/sandra-torres.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Milton Rodríguez',
          votes: 0,
          votes_percent: 0,
          block_name: 'Colombia Justa Libres',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/milton-rodriguez.png',
        },
      ],
      block: 'Colombia Justa Libres',
      settings: {
        color: '#FD7322',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '3',
      name: 'Equipo por Colombia',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Rodrigo Lara',
          votes: 0,
          votes_percent: 0,
          block_name: 'Equipo por Colombia',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/rodrigo-lara.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Federico Gutiérrez',
          votes: 0,
          votes_percent: 0,
          block_name: 'Equipo por Colombia',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/federico-gutierrez.png',
        },
      ],
      block: 'Equipo por Colombia',
      settings: {
        color: '#FF0016',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '4',
      name: 'Centro Esperanza',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Luis Murillo',
          votes: 0,
          votes_percent: 0,
          block_name: 'Centro Esperanza',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/luis-murillo.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Sergio Fajardo',
          votes: 0,
          votes_percent: 0,
          block_name: 'Centro Esperanza',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/sergio-fajardo.png',
        },
      ],
      block: 'Centro Esperanza',
      settings: {
        color: '#13911F',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '5',
      name: 'Salvación Nacional',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Carlos Cuartas',
          votes: 0,
          votes_percent: 0,
          block_name: 'Salvación Nacional',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/carlos-cuartas.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Enrique Gómez',
          votes: 0,
          votes_percent: 0,
          block_name: 'Salvación Nacional',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/enrique-gomez.png',
        },
      ],
      block: 'Salvación Nacional',
      settings: {
        color: '#0066C1',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '6',
      name: 'Pacto Histórico',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Francia Márquez',
          votes: 0,
          votes_percent: 0,
          block_name: 'Pacto Histórico',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/francia-marquez.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Gustavo Petro',
          votes: 0,
          votes_percent: 0,
          block_name: 'Pacto Histórico',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/gustavo-petro.png',
        },
      ],
      block: 'Pacto Histórico',
      settings: {
        color: '#540088',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '7',
      name: 'Colombia Piensa en Grande',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Ceferino Mosquera',
          votes: 0,
          votes_percent: 0,
          block_name: 'Colombia Piensa en Grande',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/ceferino-mosquera.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Luis Pérez',
          votes: 0,
          votes_percent: 0,
          block_name: 'Colombia Piensa en Grande',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/luis-perez.png',
        },
      ],
      block: 'Colombia Piensa en Grande',
      settings: {
        color: '#000000',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '8',
      name: 'Partido Verde Oxígeno',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'José Luis Esparza',
          votes: 0,
          votes_percent: 0,
          block_name: 'Partido Verde Oxígeno',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/jose-luis-esparza.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Ingrid Betancourt',
          votes: 0,
          votes_percent: 0,
          block_name: 'Partido Verde Oxígeno',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/ingrid-betancourt.png',
        },
      ],
      block: 'Partido Verde Oxígeno',
      settings: {
        color: '#005D09',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
  ],
  stats: [
    {
      name: 'VOTOS EN BLANCO',
      type: 'blank',
      votes: 0,
      votes_percent: 0,
      settings: {
        color: '#FFFFFF',
        class: 'bar-as-rect',
      },
    },
    {
      name: 'Votos Impugnados',
      type: 'contested',
      votes: 0,
      votes_percent: 0,
      settings: {
        color: '#FFFFFF',
        class: 'bar-as-rect',
      },
    },
    {
      name: 'Votos Nulos',
      type: 'annulled',
      votes: 0,
      votes_percent: 0,
      settings: {
        color: '#FFFFFF',
        class: 'bar-as-rect',
      },
    },
  ],
};

export default data;
